import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
import { LocalizationService } from '../../localization/localization.service';
import { Router } from '@angular/router';
import { UrlsConstants } from 'src/app/core/constants/urls.constants';

@Injectable({
  providedIn: 'root',
})
export class HandleExceptionsService {
  errorList: { [elementType: number]: (error: HttpErrorResponse) => string };

  constructor(
    private authenticationService: AuthenticationService,
    private localizationService: LocalizationService,
    private router: Router
  ) {
    this.initErrors();
  }

  public handleError(error): string {
    if (error && error instanceof HttpErrorResponse) {
      if (error.error && error.error.Status)
        return this.errorList[error.error.Status](error);
      if (error.error && error.error.status)
        return this.errorList[error.error.status](error);
      return this.errorList[error.status](error);
    }
    return this.localizationService.translate('errors.unexpectedError');
  }

  private handle401Error() {
    this.authenticationService.logout();
    this.router.navigate([UrlsConstants.LOGIN_PATH]);
    return '';
  }

  private handle400Error(error: HttpErrorResponse) {
    let errorType = '';

    if (error.error.Type) errorType = error.error.Type;
    if (error.error.type) errorType = error.error.type;
    if (
      error.error.type?.indexOf(
        'https://tools.ietf.org/html/rfc7231#section-6.5.1'
      ) === 0
    )
      errorType = 'unexpectedError';
    if(error.error.Type == 'BadRequest') errorType = 'unexpectedError';
    return this.localizationService.translate('errors.' + errorType);
  }

  private handle404Error() {
    return this.localizationService.translate('errors.notFound');
  }

  private handle405Error() {
    return this.localizationService.translate('errors.notAllowed');
  }

  private handle500Error() {
    return this.localizationService.translate('errors.unexpectedError');
  }

  private initErrors() {
    this.errorList = {};
    this.errorList[400] = (error) => this.handle400Error(error);
    this.errorList[401] = () => this.handle401Error();
    this.errorList[404] = () => this.handle404Error();
    this.errorList[405] = () => this.handle405Error();
    this.errorList[500] = () => this.handle500Error();
  }
}
